/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import FirstView from '../../asset/firstview.png';
import TheLayout from '../../layout/TheLayout';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import interviewLinkImg from '../../asset/Interviews/interview02.jpg';
import interviewImg1 from '../../asset/Interviews/Interview02/interview02_1.jpg';
import './interview_article.css';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Interview02 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const conversations = [
    {
      question: '飲食店をご経営されているということで、飲食業は対策が非常に大変だったと思いますが、感染対策はどのような対策をとられましたか。',
      answer: `コロナ禍のなか、飲食業は非常に大変でした。<br />
      TERRAの商品を導入したのも、やはりコロナがきっかけです。<br />
      緊急事態宣言が明け、完全ではないにせよ飲食店にいらっしゃるお客様は、感染対策に敏感なお客様がいらっしゃいます。<br />
      そのなかで、当店舗は何ができるかを考え、TERRAの光触媒コーティングを行いました。<br />
      公共機関も光触媒コーティングを行ってステッカーが車内に貼ってあるかと思いますが、当店舗も除菌対策に敏感なお客様でも安心してご来店頂けるよう光触媒コーティングを行いました。`,
    },
    {
      question: '他にも対策はされたのでしょうか。',
      answer: `店舗の入口にタワー型の除菌加湿器を置き、且つお客様が自由にご利用できるようにディスペンサー、エアゾールを置いております。<br />
      タワー型加湿器は、店舗の構造上入口から店舗全体に空気が流れるようになっているので、空気除菌が店舗全体に流れるように入口に置いております。`,
      img: interviewImg1,
    },
    {
      question: '対策後、お客様の反応はいかがでしたでしょうか。',
      answer: `「ヒノキの香」が良い香なので、お客様からも良い反応です。<br />
      たまに、どこで購入されたのかとお客様から聞かれることもあります。<br />
      また、店舗入口に光触媒コーティング済みのステッカーが貼ってあるので、初めてのお客様でも安心してご来店でいているのではと思っております。<br />
      私たちの店舗は、オフィス街にあり、お昼はランチで女性のお客様が多く、夜は仕事帰りの男性のお客様が多いんです。<br />
      だいたい、人数は3～4人くらいでいらっしゃることが多いので、良い香りで除菌対策をしているというのはお客様にも分かりやすいため、他と比べてもいいなと思っております。`,
    },
    {
      question: '多くの除菌対策商品がありますが、他商品と比較をしていかがですか。',
      answer: `他の商品もいろいろ見ましたが、まず何が良いかが分からなく、且つ効果が分かりにくいなと個人的に感じました。<br />
      「ひのきの香」ならば、除菌対策をしているという点でお客様にも伝わりやすいですし、オーガニックなのでどなたにも安心して使って頂けるという安心感があります。`,
    },
    {
      question: 'TERRAの商品をどういう人に勧めていきたいですか。',
      answer: `特に女性にお勧めしたいです。
      小さいタイプもありますし、オーガニックだと肌にも良いと思います。`,
    },
    {
      question: '最後に、今後TERRAに期待したいことはありますか。',
      answer: `「ひのきの香」もいいのですが、例えば季節ごとに違うパターンの香の商品などがあったらいいですね。
      そしたら、店舗の香も季節ごとに変えられて、お客様にもより一層喜んで頂けるかもしれないです。`,
    },
  ];

  const renderQnA = () => conversations.map((qna) => (
    <div className="row interview-qna" key={qna.question}>
      {
        qna.img
        && (
          <div className="col">
            <img src={qna.img} style={{ width: '100%' }} alt="" />
          </div>
        )
      }
      {
        qna.question
        && (
          <div className="col">
            <div className="interview-question">
              <span className="interview-question-dash" />
              {qna.question}
            </div>
            <div className="interview-answer" dangerouslySetInnerHTML={{ __html: qna.answer }} />
          </div>
        )
      }
    </div>
  ));

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>お客様の声｜株式会社TERRA</title>
      </Helmet>
      <div className="interview-introduction-detail">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          お客様の声
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>お客様の声</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container p-0">
          <div className="row m-0">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9 p-0">
              <div
                className="m-auto p-0 p-lg-5"
              >
                <div className="interview-post-container">
                  <h4 className="interview-post-title">
                    飲食店オーナー様も店舗でご利用！
                    <br />
                    TERRAの商品の効果は？
                  </h4>
                  <div>
                    <img src={interviewLinkImg} style={{ width: '100%' }} alt="VivaceImg" />
                  </div>
                  <div>
                    <div className="interview-name">
                      TERRA商品をご愛用者様ご利用の声vol,2
                    </div>
                    <div className="interview-intro">
                      愛知県でイングリュシュパブ
                      <span>「英吉利西屋 錦通店」</span>
                      をご経営されている
                      <br />
                      株式会社ゼアツライズ 代表取締役 平本様に店舗での利用の効果などお話をお伺い致しました。
                    </div>
                  </div>
                  <div className="interview-conversations">
                    {renderQnA(conversations)}
                  </div>
                  <div className="interview-end">
                    <p>インタビュー協力</p>
                    <p>株式会社ゼアツライズ</p>
                    <p>代表取締役　平本様</p>
                    <a
                      className="interview-vivace-link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://tabelog.com/aichi/A2301/A230102/23068594/"
                      style={{ color: '#0000FF' }}
                    >
                      https://tabelog.com/aichi/A2301/A230102/23068594/
                    </a>
                    <p>取材・文</p>
                    <p>ARIA株式会社　青山　綾子</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Interview02;
